import { InputNumber } from "antd";
import styled from "styled-components";

const NumberField = styled(InputNumber)`
  width: 100%;
`;

export { NumberField };
